import type { IdentityScope } from '@branditdev/mf-types'
import { queryOptions } from '@tanstack/react-query'
import branditRails from '../../api/brandit_rails'

const fetchIdentityScope = async () => {
  const { data } = await branditRails.get<IdentityScope>('/identity_scope')
  return data
}

export const identityScopeKeys = {
  all: ['identityScope'] as const
}

export const identityScopeQueryOptions = () =>
  queryOptions({
    queryKey: identityScopeKeys.all,
    queryFn: fetchIdentityScope
  })
